export default "__VITE_ASSET__60b0bbef__"